import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { bootstrapSSO, ensureFreshSession, startTokenRefreshLoop } from "./auth";

// Capture SSO tokens from the URL before anything renders.
bootstrapSSO();

(async () => {
  // If we were signed in but the token has expired, try a silent refresh via
  // Identity Hub first; only redirect to login if that fails (otherwise the
  // app would silently run anonymous and chat history/admin data access would
  // stop working — see auth.js). Skip rendering if a redirect was triggered.
  if (!(await ensureFreshSession())) return;

  // Keep the session alive for the rest of this tab's lifetime, so a token
  // expiring mid-conversation never silently drops the user to anonymous.
  startTokenRefreshLoop();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
})();
